<template>
  <div>
    <div class="app-nav d-none d-md-block">
      <div class="row">
        <div class="col-md-3">
          <div class="app-nav-logo">
            <a href="https://www.rubies.ng">
              <img
                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/rubies-logo.png"
                alt=""
              />
            </a>
          </div>
        </div>

        <div class="col-md-9">
          <p class="app-nav-items text-right">
            <router-link
              to="/"
              class="app-nav-item"
              :class="{ active: activePage === 'home' }"
              >Home</router-link
            >
            <router-link
              to="/donations"
              class="app-nav-item"
              :class="{ active: activePage === 'donations' }"
              >Donations</router-link
            >
            <router-link
              to="/organizations"
              class="app-nav-item"
              :class="{ active: activePage === 'organizations' }"
              >Organizations</router-link
            >
          </p>
        </div>
      </div>
    </div>

    <div class="app-nav-mini d-block d-md-none">
      <b-navbar :toggleable="true" type="dark" variant="dark">
        <b-navbar-brand href="https://www.rubies.ng/">
          <div class="app-nav-logo">
            <a href="https://www.rubies.ng">
              <img
                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/rubies-logo.png"
                alt=""
              />
            </a>
          </div>
        </b-navbar-brand>

        <b-navbar-toggle target="navbar-toggle-collapse"></b-navbar-toggle>

        <b-collapse id="navbar-toggle-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item>
              <router-link to="/">Home</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link to="/donations">Donations</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link to="/organizations">Organizations</router-link>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppNavBar",
  props: {
    activePage: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped></style>
